// extracted by mini-css-extract-plugin
module.exports = {"container":"popover_wrapper-module__container--3bqu5"};